<div fxLayout="column" fxFlexFill *ngIf="!loaders.page">

    <div class="divider layout-padd-2" ngClass.xs="layout-padd" fxLayoutAlign="start center" fxLayoutGap="10px">

        <button mat-icon-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>

        <div fxLayout="column">
            <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>
            <span class="mat-title boldest">{{"fidelityComponent.title"|translate}}</span>
        </div>

    </div>

    <div fxFlex class="scrolled">

        <!-- Points -->
        <div fxLayout="row" fxLayoutAlign="space-between center" class="divider layout-padd" ngClass.xs="layout-padd-5">

            <div>
                <span class="mat-headline" ngClass.xs="mat-title">{{"fidelityComponent.info"|translate}}</span>
            </div>

            <div>
                <!-- <span class="mat-headline boldest" ngClass.xs="mat-title">{{(merchantClient.fidelity_points?merchantClient.fidelity_points:0) |  priceFilter:'P' : 0}}</span> -->
                <span class="mat-headline boldest" ngClass.xs="mat-title">{{(merchantClient.fidelity_points_clients_dash?merchantClient.fidelity_points_clients_dash:0) |  priceFilter:'P' : 0}}</span>
                
         
            </div>

        </div>

        <!-- Tabs (Offers / History) -->
        <mat-tab-group mat-stretch-tabs>

            <!-- Offers -->
            <mat-tab label="Offres en cours">

                <div *ngIf=" fidelityOffers && fidelityOffers.length > 0" fxLayout="column">

                    <div *ngFor="let offer of fidelityOffers" class="divider layout-padd">

                        <div fxLayoutAlign="space-between center">
                            <span class="mat-title">{{offer.fidelity_rule.name | capitalize}}</span>
                            <span class="mat-caption">{{offer.fidelity_rule.output_value}}/{{offer.fidelity_rule.input_value}}</span>
                        </div>

                        <app-progress-bar colorClass="great" [value]="offer.percent">
                        </app-progress-bar>

                    </div>

                </div>
                
                <div *ngIf="!fidelityOffers || (fidelityOffers && fidelityOffers.length < 1)" fxLayoutAlign="center center" class="layout-padd">
                    <span class="mat-subheading-1">{{"fidelityComponent.noOffer"|translate}}</span>
                </div>

            </mat-tab>

            <!-- History -->
            <mat-tab label="Historique">

                <div fxLayout="column">

                    <div class="scrolled-y">

                        <table mat-table [dataSource]="dataSource" class="full-w clicked" ngClass.xs="fix-width" matSort>

                            <ng-container matColumnDef="date">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'fidelityComponent.Date'|translate}}  </th>
                                <td mat-cell *matCellDef="let fidelity">
                                    {{fidelity.date | dateFilter:"DD-MM-YYYY"}} | {{fidelity.date | dateFilter:"HH:mm"}}
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="old_value">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'fidelityComponent.oldBalance'|translate}}  </th>
                                <td mat-cell *matCellDef="let fidelity"> {{fidelity.old_value | priceFilter:'P'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="value">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'fidelityComponent.value'|translate}}  </th>
                                <td mat-cell *matCellDef="let fidelity"> {{fidelity.value | priceFilter:'P'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="new_value">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'fidelityComponent.newBalance'|translate}}  </th>
                                <td mat-cell *matCellDef="let fidelity"> {{fidelity.new_value | priceFilter:'P'}} </td>
                            </ng-container>

                            <ng-container matColumnDef="print" stickyEnd>
                                <th mat-header-cell *matHeaderCellDef> </th>
                                <td mat-cell *matCellDef="let fidelity">
                                    <div fxLayoutAlign="center center">
                                        <mat-icon class="great-ico clicked" (click)="goFidelityPrint(fidelity)" matTooltip="{{'fidelityComponent.print'|translate}}" matTooltipPosition="below" angulartics2On="click" angularticsAction="openPrintFidelity" angularticsCategory="fidelity">print</mat-icon>
                                    </div>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                        </table>

                        <div fxLayoutAlign="center center" class="layout-padd" *ngIf="!loaders.history && dataSource.data.length < 1">
                            <span class="mat-subheading-1">{{"fidelityComponent.notransaction"|translate}} </span>
                        </div>

                        <app-popup-loader [flagLoading]="loaders.history" [size]="30" [statusMessage]="'fidelityComponent.getHistory'|translate" [type]="'line'"></app-popup-loader>

                    </div>

                    <mat-paginator [pageSizeOptions]="[10, 20, 50, 100]" showFirstLastButtons></mat-paginator>

                </div>

            </mat-tab>

        </mat-tab-group>

    </div>

</div>

<app-popup-loader [flagLoading]="loaders.page" [size]="30" [statusMessage]="statusMessage">
</app-popup-loader>